import { useEffect, useState } from "react";

import { Card } from "../../../components/Card";
import { api } from "../../../services/api";
import { AxiosError } from "axios";
import { AddButton } from "../../../components/atoms/Button/AddButton";
import { ButtonListButton } from "../../../components/organisms/ButtonListBox";
import { useQuery } from "../../../hooks/query";
import { useNavigate } from "react-router-dom";
import { Table } from "../../../components/templates/Table";
import { EditButton } from "../../../components/molecules/EditButton";
import { DeleteModal } from "../../../components/templates/DeleteModal";
import { checkPermission } from "../../../utils/checkPermission";
import { useAuth } from "../../../hooks/auth";

interface Category {
  id: string;
  name: string;
}
interface Params {
  page: number;
  limit_per_page: number;
  search: string;
  order_column?: string;
  order_type?: string;
}

export function ListCategories() {
  const query = useQuery();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState<number>(0);
  const [defaultParams, setDefaultParams] = useState<Params>({
    limit_per_page: query.get("limit") ? Number(query.get("limit")) : 10,
    page: query.get("offset") ? Number(query.get("offset")) : 1,
    search: query.get("search") ?? "",
    order_column: query.get("order_column") ?? "",
    order_type: query.get("order_type") ?? "",
  });

  useEffect(() => {
    api
      .get(
        `categories/pagination?offset=${defaultParams.page}&limit=${defaultParams.limit_per_page}&search=${defaultParams.search}&order_column=${defaultParams.order_column}&order_type=${defaultParams.order_type}`
      )
      .then((response) => {
        setCategories(response.data.categories);
        setTotal(response.data.total);
        setLoading(true);
      })
      .catch((err: AxiosError) => {
        navigate(`/error/${err.response?.status}`);
      });
  }, [navigate, defaultParams]);

  return (
    <>
      <Card
        border="#216ca5"
        title="Categorias"
        header={<AddButton link="/categoria/cadastrar" />}
        body={
          <Table
            loading={loading}
            message="Buscando as categorias"
            params={defaultParams}
            setDefaultParams={(params) => {
              setDefaultParams(params);
              navigate(
                `/categorias?offset=${params.page}&limit=${params.limit_per_page}&search=${params.search}&order_column=${params.order_column}&order_type=${params.order_type}`
              );
            }}
            total={total}
            data={categories.map((category) => {
              return {
                tr: [
                  {
                    name: category.name,
                  },
                  {
                    name: (
                      <ButtonListButton>
                        <EditButton link={`/categoria/${category.id}`} />
                        {checkPermission({
                          is_admin: user.is_admin,
                          type: "Super Admin",
                        }) ? (
                          <DeleteModal
                            onDelete={(id) => {
                              setCategories(
                                categories.filter(
                                  (category) => category.id !== id
                                )
                              );
                            }}
                            id={category.id}
                            route="categories/"
                            error_message="Não foi possível remover a categoria"
                            success_message="Categoria removida com sucesso"
                          />
                        ) : (
                          <></>
                        )}
                      </ButtonListButton>
                    ),
                  },
                ],
              };
            })}
            columns={[
              {
                name: "name",
                label: "Nome",
                options: {
                  sort: true,
                },
              },
              {
                name: "action",
                label: "Ações",
                options: {
                  sort: false,
                },
              },
            ]}
          />
        }
      />
    </>
  );
}
